import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";
import { DrugtoFoodInteractions } from "../../Apis/AuthApiServices";
import useFetch from "../../CustomHooks/useFetch";
import { DrugFoodStyle } from "../../Theme";

export default function DrugToFoodInteractionPopUp(props: any) {
  const paramsData = {
    drugId: props?.drugIdforadverse,
  };
  const { data, loading, error }: any = useFetch(
    paramsData,
    DrugtoFoodInteractions,
    []
  );
  if (error)
    return (
      <>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12} md={12}>
            <Typography component={"div"} variant={"body2"} fontWeight={600}>
              Something went wrong!
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  if (loading)
    return (
      <>
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          height={"50vh"}
        >
          <CircularProgress color="primary" />
        </Grid>
      </>
    );
  return (
    <>
      <DrugFoodStyle>
        <Grid container>
          <Grid item xs={12} sm={3} className="lbl">
            <Typography component={"div"} fontWeight={600} variant={"body2"}>
              Drug Description:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography
              component={"div"}
              variant={"body1"}
              fontWeight={400}
              margin={"3px 0 6px"}
            >
              {data[0]?.drugDescription}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3} className="lbl">
            <Typography component={"div"} fontWeight={600} variant={"body2"}>
              Severity:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography
              component={"div"}
              variant={"body1"}
              fontWeight={400}
              margin={"3px 0 6px"}
            >
              {data[0]?.severity}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3} className="lbl">
            <Typography component={"div"} fontWeight={600} variant={"body2"}>
              Effect:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography
              component={"div"}
              variant={"body1"}
              fontWeight={400}
              margin={"3px 0 6px"}
            >
              {data[0]?.interaction?.effect}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3} className="lbl">
            <Typography component={"div"} fontWeight={600} variant={"body2"}>
              OnSet Description:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography
              component={"div"}
              variant={"body1"}
              fontWeight={400}
              margin={"3px 0 6px"}
            >
              {data[0]?.interaction?.onSetDescription}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3} className="lbl">
            <Typography component={"div"} fontWeight={600} variant={"body2"}>
              Description:
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9}>
            <Typography
              component={"div"}
              variant={"body1"}
              fontWeight={400}
              margin={"3px 0 6px"}
            >
              {data[0]?.interaction?.description}
            </Typography>
          </Grid>
        </Grid>{" "}
      </DrugFoodStyle>
    </>
  );
}
